import React, { Fragment, useState, useEffect } from "react";
import { print } from "graphql";
import { Mutation } from "@apollo/client/react/components";
import { Redirect, withRouter } from "react-router-dom";
import SimpleModal from "../../SimpleModal";
import SimpleForm from "../../SimpleForm";
import inputResolver from "../../SimpleForm/FieldResolver";
import UISchemaResolver from "../../../data/schema/form_ui/_resolver";
import PrefillUtil from "../../../global/utils/prefillHelper";
import util from "../../Utils/mappers";
import GQLUtil from "../../../global/utils/gqlHelper";
import { connect, useDispatch } from "react-redux";
import FormExit from "../../SimpleForm/UI/FormExit";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import {
  GET_9142A_FORM_DATA_V2,
  UPDATE_9142A_FORM_V2,
  SUBMIT_9142A_FORM_V2,
  GET_9142A_PROFILES,
} from "./queries";
import { cleanDataV2, pageLockData } from "./helpers.js";
import renderFormActions from "../renderFormActions";
import renderDeleteButton from "../renderDeleteButton";
import renderSaveButton from "../renderSaveButton";
import isTester from "../../SimpleForm/SubmissionUtilities/isTester";
import FullScreenSpinner from "../../../global/components/FullScreenSpinner";
import { usePageLock } from "../../Hooks/usePageLock";
import { fetchAllReferenceData } from "../../../global/app/actions/actions_reference";

function Form9142AV2(props) {
  const [profiles, setProfiles] = useState(null);
  const [counties, setCounties] = useState([]);
  const [formData, setFormData] = useState(undefined);
  const [form_ui, setForm_ui] = useState(undefined);
  const useRecaptcha = props.user.Recaptcha !== false;
  const { executeRecaptcha } = useGoogleReCaptcha();
  const dispatch = useDispatch();
  const pageLock = usePageLock(pageLockData);

  useEffect(() => {
    const application_type = "9142A";
    const application_id = props.match.params.id;

    // if user is currently in app and reference data updates we want to fetch latest data when they open up the form
    // before we were checking if data existed in redux and if so skipping the fetch and not getting the latest data
    dispatch(fetchAllReferenceData());

    let profiles, form;
    const fetchProfiles = async () => {
      profiles = await GQLUtil.genericGQLQuery(print(GET_9142A_PROFILES));
      const profiles_parsed = PrefillUtil.getPrefillProfileOptions(
        profiles.data.getUserProfileInfo,
        application_type,
        "all"
      );
      setProfiles(profiles_parsed);
    };
    fetchProfiles().catch(console.error);

    const fetchFormData = async () => {
      form = await GQLUtil.genericGQLQuery(print(GET_9142A_FORM_DATA_V2), {
        id: application_id,
      });
      if (form.data !== null) {
        let _formData = form.data.getForm9142AByIdV2.payload;
        let _form_ui = form.data.getForm9142AByIdV2.form_ui;
        setFormData(_formData);
        setForm_ui(_form_ui);
      } else {
        props.history.push("/dashboard/application");
      }
    };
    fetchFormData().catch(console.error);

    util
      .getCounties()
      .then((data) => setCounties(data))
      .catch((e) => console.log(`Unable to fetch counties. ${e}`));
  }, []);

  const Render9142A = () => {
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [closeModal, setcloseModal] = useState(false);
    const [modalOpen, setModalOpen] = useState(true);
    const application_type = "9142AV2";
    const resolverName = "SubmitForm9142AV2";
    const application_id = props.match.params.id;

    const handleToggle = () => {
      setcloseModal(!closeModal);
    };

    const renderFormExit = (values, form_ui, form_ui_name) => {
      return (
        <FormExit
          renderDeleteButton={() =>
            renderDeleteButton(
              application_id,
              application_type,
              props.history,
              values,
              props.user.GroupRole
            )
          }
          renderSaveButton={() =>
            renderSaveButton(
              UPDATE_9142A_FORM_V2,
              values,
              "Form9142AFormDataV2",
              application_id,
              cleanDataV2,
              props.history,
              "Save as Initiated",
              undefined,
              undefined,
              form_ui,
              form_ui_name
            )
          }
          closeModal={closeModal}
          toggleModal={handleToggle}
          values={values}
        />
      );
    };

    const formSubmissionError = (e, application_id) => {
      setFormSubmitting(false);
      if (e) {
        let type;
        let error = JSON.stringify(e);

        if (
          e &&
          e.graphQLErrors &&
          e.graphQLErrors[0] &&
          e.graphQLErrors[0].extensions
        ) {
          error = e.graphQLErrors[0].extensions;
        }
        if (
          e &&
          e.graphQLErrors &&
          e.graphQLErrors[0] &&
          e.graphQLErrors[0].message
        ) {
          type = e.graphQLErrors[0].message;
        }
        props.history.push({
          pathname: "/dashboard/error",
          state: {
            formType: application_type,
            error: error,
            application_id,
            type,
          },
        });
      }
    };

    const formSubmissionSuccess = (res) => {
      const queueError = res?.[`${resolverName}`] === "queue_error";
      setFormSubmitting(false);
      props.history.push({
        pathname: "/dashboard/success",
        state: { formType: application_type, queueError },
      });
    };

    return profiles ? (
      <Fragment>
        {!modalOpen ? (
          <Redirect to="/dashboard/application" />
        ) : (
          <SimpleModal
            fullscreen={true}
            toggleModal={handleToggle}
            modalStatus={modalOpen}
          >
            <Mutation
              onError={(e) => formSubmissionError(e, application_id)}
              onCompleted={(e) => formSubmissionSuccess(e)}
              mutation={SUBMIT_9142A_FORM_V2}
            >
              {(SubmitForm9142AV2) => (
                <SimpleForm
                  handleSubmit={
                    useRecaptcha
                      ? async (values) => {
                          if (!executeRecaptcha) {
                            return;
                          }
                          const token = await executeRecaptcha(resolverName);
                          SubmitForm9142AV2({
                            variables: {
                              Form9142AFormDataV2: cleanDataV2(values),
                              id: application_id,
                              token,
                            },
                          });
                        }
                      : (values) => {
                          SubmitForm9142AV2({
                            variables: {
                              Form9142AFormDataV2: cleanDataV2(values),
                              id: application_id,
                            },
                          });
                        }
                  }
                  toggleClose={handleToggle}
                  toggleModal={handleToggle}
                  formExit={closeModal}
                  renderFormExit={renderFormExit}
                  renderFormActions={renderFormActions(
                    UPDATE_9142A_FORM_V2,
                    "Form9142AFormDataV2",
                    application_id,
                    cleanDataV2,
                    props.history,
                    formSubmitting
                  )} // override default FormActions
                  formSaveMutation={UPDATE_9142A_FORM_V2}
                  formSaveMutationCallback={({
                    formValues,
                    formUIData,
                    saveForm,
                    profilePrefillMetadata,
                  }) => {
                    saveForm({
                      variables: {
                        formUI9142AV2: formUIData,
                        Form9142AFormDataV2: cleanDataV2(formValues),
                        id: application_id,
                        profilePrefillMetadata: profilePrefillMetadata.profiles,
                      },
                    });
                  }}
                  multiPage={true}
                  uiSchema={UISchemaResolver(application_type)}
                  uiSchema_meta={UISchemaResolver(`${application_type}-meta`)}
                  uiSchema_nav={UISchemaResolver(`${application_type}-nav`)}
                  uiSchema_lookup={UISchemaResolver(
                    `${application_type}-lookup`
                  )}
                  inputResolver={inputResolver}
                  initialValues={formData || {}}
                  profiles={profiles}
                  counties={counties}
                  form_ui={form_ui}
                  form_ui_name={"formUI9142AV2"}
                  formSubmitting={formSubmitting}
                  pageLock={pageLock}
                  disableValidation={
                    (props.user &&
                      props.user.Roles &&
                      isTester(props.user && props.user.Roles)) ||
                    false
                  }
                />
              )}
            </Mutation>
          </SimpleModal>
        )}
      </Fragment>
    ) : null;
  };

  if (
    formData !== undefined &&
    form_ui !== undefined &&
    profiles !== null &&
    counties?.length !== 0
  ) {
    return (
      <div>
        <Render9142A />
      </div>
    );
  }
  return <FullScreenSpinner />;
}

const mapStateToprops = (props) => {
  return {
    user: props.appReducer.userDataReducer.data,
  };
};

export default withRouter(connect(mapStateToprops, null)(Form9142AV2));
